import React from 'react';
import {
  FillableFormField,
} from 'views/EMR/components/FillableForm/types';
import {
  getFieldDisplayLabel,
  isFormFieldStrictlyRequired,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

type Props = {
  field: FillableFormField;
  id: string;
};

export default function FormFieldWizardLabel({
  field,
  id,
}: Props) {
  const text = getFieldDisplayLabel(field);
  const isRequired = isFormFieldStrictlyRequired(field);

  return !text ? null : (
    <label htmlFor={id} className="font-semibold">
      {text}
      {!isRequired && (
        <span className="text-[11px] italic font-normal text-gray-400 ml-1">(Optional)</span>
      )}
    </label>
  );
}
